<template>
    <DataComponent
        class="w-full mt-6"
        :data="data"
        :initialSort="initialSort"
        :disableSort="disableSort"
        @sort="onSort">
        <DataField name="start" class="whitespace-no-wrap md:text-sm">
            <template v-slot="{row}">
                <router-link
                    :to="{ name: 'admin.courses.session-groups.show', params: {courseId: row.course_id, courseSessionGroupId: row.id}}"
                    class="text-indigo-600 hover:text-indigo-900">
                    <CalendarFormat :date="getStartDate(row)" :show-state="false"/>
                </router-link>
            </template>
        </DataField>
        <DataField name="end" class="whitespace-no-wrap md:text-sm">
            <template v-slot="{row}">
                <router-link
                    :to="{ name: 'admin.courses.session-groups.show', params: {courseId: row.course_id, courseSessionGroupId: row.id}}"
                    class="text-indigo-600 hover:text-indigo-900">
                    <CalendarFormat :date="getEndDate(row)" :show-state="false"/>
                </router-link>
            </template>
        </DataField>
        <DataField name="spaces" class="whitespace-no-wrap md:text-sm"/>
        <DataField name="actions" :sortable="false" :showLabel="false" :showResponsiveLabel="false">
            <template v-slot="{row}">
                <div class="flex justify-around md:justify-end items-center">
                    <router-link
                        v-if="row.user_can.update"
                        class="text-indigo-600 hover:text-indigo-900 mr-4"
                        :to="{name: 'admin.courses.session-groups.edit', params: {courseId: row.course_id, courseSessionGroupId: row.id}}">
                        Edit
                    </router-link>
                    <button
                        v-if="row.user_can.delete"
                        class="text-red-600" @click.prevent="confirmDelete(row)">Delete
                    </button>
                </div>
            </template>
        </DataField>
    </DataComponent>
</template>

<script>

import {DataComponent, DataField} from "@/Components/DataComponent";
import CalendarFormat from "@/Components/CalendarFormat";
import dayjs from "dayjs";
import {sortBy} from "lodash";
import axios from "axios";

export default {

    name: "CourseSessionGroupsDataComponent",

    props: {
        ...DataComponent.props
    },

    data() {
        return {}
    },

    components: {
        DataComponent,
        DataField,
        CalendarFormat,
    },

    methods: {
        onSort(data) {
            this.$emit('sort', data);
        },
        getStartDate(sessionGroup) {
            const sessions = sortBy(sessionGroup.sessions, session => dayjs(session.start));

            return sessions[0].start;
        },
        getEndDate(sessionGroup) {
            const sessions = sortBy(sessionGroup.sessions, session => dayjs(session.end)).reverse();

            return sessions[0].end;
        },
        confirmDelete(sessionGroup) {
            if (window.confirm('Are you sure you want to delete this Session?')) {
                axios.delete(route('api.course-session-groups.destroy', sessionGroup))
                    .then(() => {
                        this.$notify.success('Session deleted');
                        this.$emit('remove:sessionGroup', )
                    })
                    .catch(console.error);


            }
        }
    },

    computed: {}
};

</script>
